const isDev = /^dev-/.test(location.hostname)
export const baseURL =  '/api' // isDev ? 'https://dev-api.yqba.live/' : 'https://api.yiqi8.live/'
export const cdnDomain = 'https://www.123bangong.cn/'